import {createAction} from 'redux-actions';
import {actionTypes as system} from '../System';
import {handleActions} from '../../Utility/HandleActions';

//
// actionTypes
//
const TOGGLE_CALENDAR = 'DBM/UI/SETTLEMENT/TOGGLE_CALENDAR';
const TOGGLE_FIXING_TIME = 'DBM/UI/SETTLEMENT/TOGGLE_FIXING_TIME';

//
// Create actions
//
const toggleCalendar = createAction(TOGGLE_CALENDAR);
const toggleFixingTime = createAction(TOGGLE_FIXING_TIME);


export const actionTypes = {
    TOGGLE_CALENDAR,
    TOGGLE_FIXING_TIME
};

export const actions = {
    toggleCalendar,
    toggleFixingTime
};

//
// Export reducer
//
export const reducer = handleActions({
    [system.INIT]: () =>
        (state) => {
            let newState = state;
            newState = newState.setIn(['ui', 'settlement', 'calendar', 'visibility'], false);
            newState = newState.setIn(['ui', 'settlement', 'fixingtime', 'late'], false);
            return newState;
        }
    ,

    [TOGGLE_CALENDAR]: () =>
        (state) => {
            return state.setIn(['ui', 'settlement', 'calendar', 'visibility'], !state.getIn(['ui', 'settlement', 'calendar', 'visibility']));
        }
    ,

    [TOGGLE_FIXING_TIME]: () =>
        (state) => {
            return state.setIn(['ui', 'settlement', 'fixingtime', 'late'], !state.getIn(['ui', 'settlement', 'fixingtime', 'late']));
        }
});

const isCalendarVisible = (state) => state.getIn(['ui', 'settlement', 'calendar', 'visibility']);
const isFixingTimeLate = (state) => state.getIn(['ui', 'settlement', 'fixingtime', 'late']);


export const selectors = {
    isCalendarVisible,
    isFixingTimeLate
};
